import { HttpContextToken } from '@angular/common/http';

// Kept in a dependency-free file so services/interceptors don't have to import `app.config` (which pulls in `app.routes`).
export const appHTTPContext = new HttpContextToken<string>(() => '');
export const skipLoadingSpinnerContext = new HttpContextToken<boolean>(() => false);
